import { type IEditorConfigOptions } from './ConfigBuilder';
import { ToolbarGroups } from './registry';

const createDocumentPreset = (): IEditorConfigOptions => {
  return {
    core: { height: 600, menubar: false, statusbar: true, branding: false },
    features: {
      content: {
        lists: true,
        links: true,
        images: true,
        tables: true,
        searchReplace: true,
        anchor: true,
      },
      formatting: {
        textStyle: true,
        alignment: true,
        underline: true,
        removeFormat: true,
        indent: true, // TODO: check this
        charmap: true,
        bold: true,
        italic: true,
        strikethrough: true,
        fonts: true,
      },
      utility: {
        code: true,
        fullscreen: true,
      },
      template: {
        variables: true,
        loops: true,
        conditions: true,
        functions: true,
      },
      history: {
        undo: true,
        redo: true,
      },
    },
    toolbarGroups: [
      ToolbarGroups.History,
      ToolbarGroups.Template,
      ToolbarGroups.TextStyle,
      ToolbarGroups.Formatting,
      ToolbarGroups.Alignment,
      ToolbarGroups.Lists,
      ToolbarGroups.Link,
      ToolbarGroups.Media,
      ToolbarGroups.Table,
      ToolbarGroups.Utility,
      ToolbarGroups.Fonts,
    ],
  };
};

const createMinimalPreset = (): IEditorConfigOptions => {
  return {
    core: { height: 300, menubar: false, statusbar: false, branding: false },
    features: {
      formatting: {
        underline: true,
        bold: true,
        italic: true,
      },
    },
    toolbarGroups: [ToolbarGroups.Formatting],
  };
};

const createBasicTextPreset = (): IEditorConfigOptions => {
  return {
    core: { height: 400, menubar: false, statusbar: false, branding: false },
    features: {
      content: {
        lists: true,
        links: true,
      },
      formatting: {
        alignment: true,
        underline: true,
        bold: true,
        italic: true,
      },
    },
    toolbarGroups: [
      ToolbarGroups.Formatting,
      ToolbarGroups.Lists,
      ToolbarGroups.Link,
      ToolbarGroups.Media,
      ToolbarGroups.Table,
      ToolbarGroups.Alignment,
    ],
  };
};

export const EditorPresets = {
  BASIC_TEXT: createBasicTextPreset(),
  MINIMAL: createMinimalPreset(),
  TEMPLATE: createDocumentPreset(),
} as const;
